<template>
    <div>
      <p-card class='border-0'>
      <b-row class="padding-top"  v-for="(locationItem, locationIndex) in this.computedLocations"  :key="locationIndex">
          <b-col class="text-center">
              <div class="text-start">{{ locationItem.locationName }}</div>
              <b-button v-if="selectedLocation === locationItem.locationId"
                    variant="primary"
                    class="margin-top float-start"
                    @click="expandAll = !expandAll">
                    {{expandAll ? 'See Current Location' : 'See All Locations'}}
                </b-button>
          </b-col>
          <b-col cols="8">
            <b-row cols="3">
              <b-col v-for="(item, index) in locationItem.dccChartsOfAccountTypes" :key="index" class="text-center pb-3">
                  <h5 class="text-start">{{ item.chartOfAccountsTypeName }}</h5>
                  <p-advanced-select  
                        data-type="chartOfAccounts"
                        v-model="item.chartOfAccountsId"
                        :filter="filterChartOfAccounts"
                        :additional-filter-parameter="item"
                        :add-invalid-option="{value:-1, text:'----Mixed----', abbreviation:'----Mixed----', hidden: true}"
                        @change="itemChanged(item, locationItem)"
                    />                      
              </b-col>
            </b-row>
          </b-col>
          <b-col></b-col>
      </b-row>
    </p-card>
    </div>
  </template>

  <script>
    import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';

    export default {
      props: {
        itemDcc: {
          type: Object,
          required: true
        }
    }, 
    data() {
      return {
        selectedLocation : 0,
        expandAll: false,
        filteredLocations: []
      }},     
      methods: {
        filterChartOfAccounts(chartOfAccount, item) {
          return chartOfAccount.type === item.chartOfAccountsTypeName || chartOfAccount.type == null;
        },
        itemChanged(item, locationItem){
          item.isChanged = true;   
          this.$emit('chart-of-account-type-change', this.itemDcc, locationItem, item);
        }
      },
      mounted: async function () {
        this.selectedLocation = await selectListOptionsDataContext.getSelectedLocationIdAsync();
      },
      computed:{
        computedLocations() {          
            var locations = this.itemDcc?.dccCategoryChartOfAccountsTypes?.locations.filter(location => location.locationId === this.selectedLocation);
            if (this.expandAll)
              locations = this.itemDcc?.dccCategoryChartOfAccountsTypes.locations;

            if(locations && locations.length > 0 && (this.itemDcc?.dccLevel === "Department" || this.itemDcc?.dccLevel === "Class")){  
              locations.every(location => location.dccChartsOfAccountTypes.map(dccChartsOfAccountType => dccChartsOfAccountType.isChanged = true));
            }

            return locations;
          }
      }        
    };
  </script>
  <style scoped>
    .container {
      margin-left: 40px;
      margin-right: 40px;
    }
    .text-center {
      text-align: center;
    }
    .text-start {
      text-align: left;
    }
    .padding-top {
      padding-top: 45px;
    }
    .margin-top {
      margin-top: 45px;
    }
  </style>